export default "__VITE_ASSET__7c4005eb__"